import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import companies from '../data/companyData';

const CompanyPage = () => {
  const { slug } = useParams();
  const company = companies.find((item) => item.slug === slug) || companies[0];

  return (
    <div className="section-padding fade-in" style={{ backgroundColor: '#f5f3ef', minHeight: '100vh' }}>
      <Container style={{ maxWidth: '1180px', backgroundColor: '#f5f3ef', padding: '30px 20px 50px' }}>
        <div className="fade-in" style={{ backgroundColor: '#f8f7f3', borderRadius: '20px', border: '1px solid rgba(146, 118, 75, 0.25)', boxShadow: '0 8px 30px rgba(0,0,0,0.06)', padding: '24px' }}>
          <Row className="align-items-center g-4 g-lg-5">
            <Col lg={6}>
              <div style={{ overflow: 'hidden', borderRadius: '18px', border: '1px solid rgba(146, 118, 75, 0.2)', boxShadow: '0 12px 30px rgba(0,0,0,0.08)' }}>
                <img
                  src={company.imageUrl}
                  alt={company.name}
                  style={{ width: '100%', height: '420px', objectFit: 'cover', display: 'block' }}
                />
              </div>
            </Col>

            <Col lg={6}>
              <h1 style={{ fontSize: 'clamp(2rem, 2.5vw, 3rem)', color: '#1e3d2f', fontWeight: 500, lineHeight: '1.2', marginBottom: '20px', fontFamily: 'Georgia, serif' }}>
                {company.name}
              </h1>
              <p style={{ fontSize: '1.15rem', lineHeight: '1.8', color: '#485b50', margin: 0 }}>
                {company.description}
              </p>
            </Col>
          </Row>

          <div style={{ borderTop: '1px solid rgba(146, 118, 75, 0.25)', marginTop: '32px', paddingTop: '28px' }}>
            <h2 style={{ fontSize: '2rem', color: '#2c3f37', marginBottom: '28px', fontFamily: 'Georgia, serif', fontWeight: 600 }}>
              Divisions & Services
            </h2>

            <Row className="g-4">
              {company.services.map((service, index) => (
                <Col md={6} lg={3} key={index}>
                  <div
                    className="card-modern fade-in"
                    style={{
                      backgroundColor: '#fff',
                      border: '1px solid rgba(146, 118, 75, 0.25)',
                      borderRadius: '18px',
                      overflow: 'hidden',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      boxShadow: '0 6px 18px rgba(0,0,0,0.05)',
                      animationDelay: `${index * 0.12}s`
                    }}
                  >
                    <div style={{ position: 'relative', height: '220px', backgroundImage: `url(${service.imageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                      <div style={{ position: 'absolute', width: '58px', height: '58px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.9)', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem', boxShadow: '0 4px 15px rgba(0,0,0,0.12)' }}>
                        {service.icon}
                      </div>
                    </div>

                    <div style={{ padding: '22px 18px 18px', display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                      <h3 style={{ fontSize: '1.7rem', color: '#1e3d2f', marginBottom: '14px', fontFamily: 'Georgia, serif', fontWeight: 600 }}>
                        {service.title}
                      </h3>
                      <p style={{ color: '#556b60', fontSize: '1rem', lineHeight: '1.7', marginBottom: '18px', flexGrow: 1 }}>
                        {service.description}
                      </p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CompanyPage;
